import React, { useContext } from "react";

import isTouchDevice from "../SE-Component/Tooltip";
import embLabels from "../../config/emb-labels-en.json";
import { InformationPageContext } from "../CustomHooks/ContextApi";

const GSXSiteType = () => {
  const { informationToolTIP, siteType, handleSiteTypeChangeGSX } = useContext(
    InformationPageContext
  );
  return (
    <>
      <div className="row">
        <div className="col-md-12 mt-1">
          <span className="labelCircle mr-2 ">1</span>
          <span>Select your Microgrid type</span>
          <se-tooltip
            action={isTouchDevice() ? "click" : "hover"}
            position="right"
          >
            <se-icon
              option="raised"
              color="secondary"
              size="small"
              slot="tooltip"
            >
              information_circle
            </se-icon>
            <se-tooltip-content>Select your Microgrid type</se-tooltip-content>
          </se-tooltip>
        </div>
      </div>

      <div className="row is-flex mt-2">
        <div className="col-md-4">
          <div
            className={`col-md-12 ${
              siteType === embLabels.GRID_CONNECTED_GSX
                ? "border-green-radius-5px"
                : "border-radius-5px"
            }`}
          >
            <div className="row align-items-center">
              <div className="col-md-2">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadio1"
                      name="siteType"
                      className="custom-control-input islandableRadio asCompatible"
                      value="GRID_CONNECTED_GSX"
                      checked={
                        siteType === embLabels.GRID_CONNECTED_GSX ? true : false
                      }
                      onChange={handleSiteTypeChangeGSX}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadio1"
                    >
                      &zwnj;
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-10 p-2">
                <div className="row">
                  <div className="col-md-12 mt-1">
                    <span className="bold">Always grid connected site</span>
                  </div>
                  <div className="col-md-12 mt-1">
                    <span>"{informationToolTIP.gridConnectedTooltipData}"</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div
            className={`col-md-12 ${
              siteType === embLabels.ISLANDABLE_GSX
                ? "border-green-radius-5px"
                : "border-radius-5px"
            }`}
          >
            <div className="row align-items-center">
              <div className="col-md-2">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadio2"
                      name="siteType"
                      className="custom-control-input islandableRadio asCompatible"
                      value="ISLANDABLE_GSX"
                      checked={
                        siteType === embLabels.ISLANDABLE_GSX ? true : false
                      }
                      onChange={handleSiteTypeChangeGSX}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadio2"
                    >
                      &zwnj;
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-10 p-2">
                <div className="row">
                  <div className="col-md-12 mt-1">
                    <span className="bold">Islandable site</span>
                  </div>
                  <div className="col-md-12 mt-1">
                    <span>"{informationToolTIP.islandableTooltipData}"</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GSXSiteType;
